import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

import { RejectReasonMenu, verdictButtonSx } from '../VerdictBar';

/**
 * The entity's verdict, in a hero page's action bar.
 */
export default function HeroVerdictActions(props) {
  const { onDecide, disabled } = props;
  const [reasonAnchor, setReasonAnchor] = useState(null);

  return (
    <>
      <Box
        component="button"
        type="button"
        disabled={disabled}
        onClick={() => onDecide('approve', null)}
        sx={verdictButtonSx('approve')}
      >
        <CheckIcon sx={{ fontSize: 17 }} />
        Approve
      </Box>
      <Box
        component="button"
        type="button"
        disabled={disabled}
        onClick={(event) => setReasonAnchor(event.currentTarget)}
        sx={verdictButtonSx('reject')}
      >
        <CloseIcon sx={{ fontSize: 17 }} />
        Reject
      </Box>
      <RejectReasonMenu
        anchorEl={reasonAnchor}
        placement="below"
        onClose={() => setReasonAnchor(null)}
        onPick={(reason) => onDecide('reject', reason)}
      />
    </>
  );
}

HeroVerdictActions.propTypes = {
  onDecide: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

HeroVerdictActions.defaultProps = { disabled: false };
